const TEMPORARY_ACCESS_TOKEN = "temporary_access_token";

const DISABLE_ADS = "disable_ads";

const AUTH_DATA = "auth_data";

const load = (key: string) => () => {
  const storage = getLocalStorage();

  if (!storage) {
    return null;
  }

  const serializedValue = storage.getItem(key);

  if (serializedValue === null) {
    return serializedValue;
  }

  try {
    return JSON.parse(serializedValue);
  } catch (e) {
    return serializedValue;
  }
};

const set = (key: string) => (value?: any) => {
  if (typeof value !== "undefined" && value !== null) {
    const storage = getLocalStorage();

    if (storage) {
      const serializedValue = ["object", "array"].includes(typeof value)
        ? JSON.stringify(value)
        : value;

      storage.setItem(key, serializedValue);
    }
  } else {
    remove(key)();
  }
};

const remove = (key: string) => () => {
  const storage = getLocalStorage();

  if (storage) {
    storage.removeItem(key);
  }
};

const getLocalStorage = () => {
  try {
    return localStorage;
  } catch (e) {
    const { name, message } = e as Error;
    // eslint-disable-next-line
    console.log(name, message);
  }

  return null;
};

export const loadTemporaryAccessToken = load(TEMPORARY_ACCESS_TOKEN);

export const loadDisableAds = load(DISABLE_ADS);

export const loadAuth = load(AUTH_DATA);

export const setTemporaryAccessToken = set(TEMPORARY_ACCESS_TOKEN);

export const setAuth = set(AUTH_DATA);
